module.exports = __webpack_public_path__ + "img/s6.1b927d4f.png";